import React from 'react'
import LogoutIcon from '@material-ui/icons/PowerSettingsNew'
import ListItem from './ListItem';
import OAuthService from 'services/OAuthService';
import Tr from 'translations/Translations';

function LogoutButton() {
	return (
		<ListItem
			name={Tr('logout')}
			Icon={LogoutIcon}
			onClick={ () => OAuthService.logout()}
		/>
	)
}

export default LogoutButton
